import type { UseFormRegisterReturn } from "react-hook-form";
import { useFormContext } from "react-hook-form";

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Textarea,
} from "@/components/ui";
import { cn } from "@/lib/utils/cn";

export interface TextAreaFormFieldProps {
  label?: string;
  type?: HTMLInputElement["type"];
  className?: string;
  textAreaClassName?: string;
  register: UseFormRegisterReturn;
  disabled?: boolean;
}

export const TextAreaFormField = ({
  label,
  className,
  textAreaClassName,
  register,
  disabled,
}: TextAreaFormFieldProps) => {
  const form = useFormContext();
  return (
    <FormField
      control={form.control}
      {...register}
      // @ts-expect-error This line is to remove a console error
      ref={null}
      render={({ field }) => (
        <FormItem className={className}>
          <div className="flex">
            {label && <FormLabel>{label}</FormLabel>}
            <FormMessage
              data-testid="error-message"
              className="grow text-right"
            />
          </div>
          <FormControl>
            <Textarea
              className={cn(
                "field-sizing-content max-h-[20lh]",
                textAreaClassName,
              )}
              {...field}
              disabled={disabled}
              ref={null}
            ></Textarea>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
